import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { finalNeeds, systemLines } from '../data/content';
export function FinalCta() {
  return <section className="bg-brand-900 px-4 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-124" data-mp="19epbnpjoh0wh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-125" data-mp="15ddixb5ibzk2">
        <h2 id="final-title" className="font-serif text-[32px] font-bold leading-[1.12] text-white sm:text-5xl" data-id="element-126" data-mp="15bsmffzmu6jk">
          Ready to stop collecting techniques…
          <em className="mt-1 block text-gold-light" data-id="element-127" data-mp="1eek0lnjw7gew">…and start practicing?</em>
        </h2>

        <ul className="mt-8 space-y-2 text-[17px] text-brand-100" data-id="element-128" data-mp="1t2olmy6f440u">
          {finalNeeds.map(n => <li key={n} data-id="element-129" data-mp="1o3bp1lpqvil2">{n}</li>)}
        </ul>

        <p className="mt-8 text-sm font-bold uppercase tracking-wider text-brand-200" data-id="element-130" data-mp="1o5y7ige6bii2">You can start with:</p>
        <div className="mt-3 space-y-1" data-id="element-131" data-mp="221a12kglf2xe">
          {systemLines.map(l => <p key={l} className="font-serif text-2xl font-bold uppercase text-white sm:text-3xl" data-id="element-132" data-mp="1x6cudk6sd5no">
              {l.replace('One simple system.', 'One clear system.')}
            </p>)}
        </div>

        <p className="mt-8 font-serif text-6xl font-bold text-gold-light" data-id="element-133" data-mp="s6s0y5kg81e1">
          $27 <span className="font-sans text-xl text-brand-100" data-id="element-134" data-mp="x27curywbn7t">USD</span>
        </p>

        <div className="mt-6" data-id="element-135" data-mp="123wmc36gzsts">
          <CtaButton label="I want the Apometry Practice Deck™" data-id="element-136" data-mp="120sd2re5e6w9" />
          <p className="mt-3 text-sm text-brand-100" data-id="element-137" data-mp="163fcbdd5eu3h">
            Instant download · Lifetime access · One-time payment · 7-day guarantee
          </p>
          <Countdown dark data-id="element-138" data-mp="1fu9wmc6u3jma" />
        </div>
      </div>
    </section>;
}